import { createAttachmentsApi } from '#/api/platform/attachments';

/** 付款憑證附件：owner＝付款紀錄，讀寫走 `fms.purchase_payment.read`／`update`，不沿用採購附件權限。 */
export const purchasePaymentRecordAttachmentsApi = createAttachmentsApi(
  (recordId) => `/fms/purchase-payment-records/${recordId}/attachments`,
);
